<div class="container">
  <div class="title-wrap">
    <h1 class="title" (click)="backToAppsList()">
      <svg role="img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z">
        </path>
      </svg>
      {{ 'pages.apps.actions.add' | translate }}
    </h1>

    <div class="actions">
      <button class="btn btn__secondary btn__icon" *ngIf="!isLoading" (click)="addMedia()">
        <span class="add">{{ 'pages.apps.actions.medias' | translate }}</span>
      </button>
      <button class="btn btn__primary" (click)="create()" [disabled]="form.invalid || isLoading">
        <ng-container *ngIf="isLoading; else add">
          <mat-spinner diameter="22" color="secondary"></mat-spinner>
        </ng-container>
        <ng-template #add>{{ 'pages.apps.actions.create' | translate }}</ng-template>
      </button>
    </div>
  </div>

  <form class="form" [formGroup]="form">
    <div class="params">
      <div class="params__fields">
        <mat-form-field class="login-wrap__text">
          <mat-label>{{ 'pages.apps.form.name' | translate }}</mat-label>
          <input matInput appFormInputTrim type="text" formControlName="name">
          <mat-error *ngIf="form.controls.name.touched">
            <span *ngIf="form.controls.name.errors?.required">{{ 'pages.specials.modal.required' | translate }}</span>
            <span *ngIf="form.controls.name.errors?.minlength">{{ 'pages.app.form.errors.minlength' | translate }}</span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="login-wrap__text">
          <mat-label>{{ 'pages.apps.form.description' | translate }}</mat-label>
          <input matInput appFormInputTrim type="text" formControlName="description">
          <mat-error *ngIf="form.controls.description.touched">
            <span *ngIf="form.controls.description.errors?.maxlength">{{ 'pages.app.form.errors.maxlength' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="params__fields">
        <fieldset class="restaurants" formGroupName="restaurants">
          <legend>{{ 'pages.apps.form.apply' | translate }}</legend>

          <mat-radio-group class="mode" formControlName="mode">
            <mat-radio-button color="primary" value="all">
              {{ 'pages.apps.form.addToAllRest' | translate }}
            </mat-radio-button>
            <mat-radio-button color="primary" value="custom">
              {{ 'pages.apps.form.custom' | translate }}
            </mat-radio-button>
          </mat-radio-group>

          <div *ngIf="restaurantsFormGroup.get('mode')?.value === 'custom'" [@slideFormField] class="rest-ids-wrapper">
            <mat-form-field class="login-wrap__text rest-ids">
              <mat-label>{{ 'pages.apps.form.restaurants' | translate }}</mat-label>
              <mat-select formControlName="ids" multiple>
                <mat-option *ngFor="let restaurant of allRestaurants$ | async" [value]="restaurant.id">
                  {{ restaurant.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </fieldset>

        <mat-checkbox
          class="published-checkbox"
          color="primary"
          formControlName="published"
        >
          {{ 'pages.apps.form.published' | translate }}
        </mat-checkbox>
      </div>
    </div>

    <div class="config-section">
      <app-app-config-device
        [app]="this.app"
        [config]="form.get('config')?.value"
        [files]="this.files"
      ></app-app-config-device>

      <app-config-form
        [app]="this.app"
        [config]="form.get('config')?.value"
        [files]="this.files"
        (configChange)="form.get('config')?.setValue($event)"
        (openFileManager)="addMedia()"
      ></app-config-form>
    </div>
  </form>


  <ng-template #loading>
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>

</div>
